export const GET_ENTITY_TYPES = 'entity-profiles/GET_ENTITY_TYPES'
export const GET_ENTITY_TYPE = 'entity-profiles/GET_ENTITY_TYPE'
export const ADD_ENTITY_TYPE = 'entity-profiles/ADD_ENTITY_TYPES'
export const EDIT_ENTITY_TYPE = 'entity-profiles/EDIT_ENTITY_TYPES'
export const DELETE_ENTITY_TYPES = 'entity-profiles/DELETE_ENTITY_TYPES'
export const START_LOADING_ENTITY_TYPES =
  'entity-profiles/START_LOADING_ENTITY_TYPES'
export const STOP_LOADING_ENTITY_TYPES =
  'entity-profiles/STOP_LOADING_ENTITY_TYPES'
